<template>
  <div class="profile-steps">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 cus-step-wrap">
        <div class="flex_content py-4">
          <ProgressBar :scale="progress" v-if="$route.query['data-id']" />
        </div>
        <div class="step-progress__wrapper">
          <div class="step-progress__bar md-layout">
            <div class="md-medium-size-33 md-layout-item md-xsmall-size-100 custom-step-pro p-0">
              <div
                id="industryDiv"
                class="step-progress__step step-progress__step--valid"
                @click="selectedTab($event)"
              >
                <span class="step">1</span>
                <div class="step-progress__step-icon fa fa-check"></div>
                <div class="step-progress__step-label">
                  <div class="arrow-up"></div>Industry</div>
                <div class="step-progress__step-sub-label">
                  <div class="progress-step-actions">
                    <div class="action-text" @click="getData($store.getters.industry)?resetIndustry():openSelector()">
                      {{
                        getData($store.getters.industry)
                          ? getData($store.getters.industry)
                          : 'Select Industry'
                      }}
                      <md-icon v-if="$store.getters.industry != null" class="action-icon">replay</md-icon>
                    </div>
                    <div
                      class="favourite"
                      v-if="$store.getters.industry != null"
                      @click="favoriteIndustry()"
                    >
                      <md-icon v-if="$store.getters.industry != null" class="action-icon">star</md-icon>Add to Favorite
                    </div>
                  </div>
                </div>
                <div class="dropdownMenu">
                  <nav-tabs-card no-label md-elevation="0">
                    <template slot="content">
                      <md-tabs md-alignment="left" id="finantialProfileTabs">
                        <industry-tab />
                      </md-tabs>
                    </template>
                  </nav-tabs-card>
                </div>
              </div>
              <div id="favoritesDiv" :class="this.isRetail?'non-subscriber favourite_list':'favourite_list'"  @click="isRetail?{}:favorites($event)">
                <md-tooltip v-if="this.isRetail" md-direction="right" class="width-tooltip">Upgrade to a subscription to access this feature</md-tooltip>
                <i class="md-icon">star</i>Favorite Industries
                <div class="dropdownMenu" v-click-outside-component="close">
                  <sidebar-search tab="industry" title="Favorite Industries" />
                </div>
                <div id="industry_notify" class="notify">Successfully Added to Favorite</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ProgressBar } from '@/components';
import axios from 'axios';
import { NavTabsCard } from '@/components';
import IndustryTab from './IndustryTab';
import SidebarSearch from './SidebarSearch';
import { mapState } from 'vuex';
export default {
  name: 'industry-select',
  components: {
    NavTabsCard,
    IndustryTab,
    SidebarSearch,
    ProgressBar
  },
  data() {
    return {
      classicModal: false,
      progress: 70,
    };
  },
  methods: {
    openSelector: function (){
      let selectorDiv = document.getElementById('industryDiv');
      if(selectorDiv.classList.contains('open'))
         selectorDiv.classList.remove('open');      
      else
        selectorDiv.classList.add('open');
    },
    close: function() {
      var elem = document.getElementById('favoritesDiv');
      elem.classList.remove('open');
    },
    selectPanel(e) {
      let activeClass = e.target.parentElement;
      if (activeClass.classList.contains('open')) {
        activeClass.classList.remove('open');
      } else {
        activeClass.classList.add('open');
      }
    },
    getData: function (name) {
      if (name) {
        return name.split('[')[1].split(']')[0];
      }
    },
    getTitle: function (name) {
      if (name) {
        return name.split('[')[0];
      }
    },
    favoriteIndustry: async function () {
      let notify = document.getElementById('industry_notify');
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );
      const industryData = this.getData(this.$store.getters.industry);
      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/favorites/add',
          {},
          {
            params: {
              session_id: currentSession,
              category1: 'universal',
              category2: 'industry',
              data: industryData,
              search1: this.$store.getters.industry,
              search2: industryData,
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/favorites/add" <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          this.$store.commit('PUSH_TO_FAVORITE_INDUSTRIES', {
            data: industryData,
            search1: this.$store.getters.industry,
            id: res.data.favorite_id,
          });
          notify.classList.add('show');
          setTimeout(function () {
            notify.classList.remove('show');
          }, 3000);
        });
    },
    resetIndustry: async function () {
      this.$store.commit('SET_INDUSTRY', null);
     /* this.progress;
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );
      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/search_profiles/company',
          {},
          {
            params: {
              session_id: currentSession,              
              profile_id: this.profileId ? this.profileId : '0',             
              type:'company',                
            },          
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/search_profiles/company" <br>`
            );
            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          const { id } = res.data;
          this.$store.commit('SET_PROFILE_ID', id);
        });
        */
    },
    toArray: function (arrLike) {
      return [].slice.call(arrLike);
    },
    setIndustryClass: function () {
      let div = document.querySelector('#industryDiv');

      if (div) {
        if (this.$store.getters.industry != null) {
          div.classList.remove('step-progress__step--valid');
          div.classList.add('step-progress__step--active');
        } else {
          div.classList.remove('step-progress__step--active');
          div.classList.add('step-progress__step--valid');
        }
      }
    },
    favorites: function (e) {
      let industryDiv = document.getElementById('industryDiv');
      if (industryDiv.classList.contains('open')) {
        industryDiv.classList.remove('open')
      }

      let activeClass = e.target;
      e.stopPropagation();
      if (activeClass.classList.contains('open')) {
        activeClass.classList.remove('open');
      } else {
        activeClass.classList.add('open');
      }
    },
    selectedTab: function (e) {
      let favoritesDiv = document.getElementById('favoritesDiv');
      if (favoritesDiv.classList.contains('open')) {
        favoritesDiv.classList.remove('open')
      }

      let activeClass = e.target.parentElement;
      e.stopPropagation();

      if (activeClass.classList.contains('open')) {
        activeClass.classList.remove('open');
      } else {
        let elems = document.querySelector('.progress-step-actions');

        [].forEach.call(elems, function (el) {
          el.classList.remove('open');
        });
        activeClass.classList.add('open');
      }
      let elems = this.toArray(document.querySelectorAll('.md-tab-nav-button'));
      elems.forEach(function (el) {
        el.classList.remove('md-active');
      });
      let currentTab = parseInt(e.currentTarget.firstElementChild.innerText);
      document
        .querySelectorAll('.md-tab-nav-button')
      [currentTab - 1].classList.add('md-active');
    },
  },
  computed: {
     ...mapState({
      isRetail: (state) => (state.user.user_type.retail/* || state.user.allow_retail*/) ?true: null,
      userType: (state) => state.user.user_type,
    }),
    profileId() {
      return this.$store.getters.profileId;
    },
    industry() {
      return this.$store.getters.industry;
    },
  },
  watch: {
    industry(newValue, oldValue) {
      this.setIndustryClass();
      if (newValue) {
        this.progress += 10;
      }
      if (oldValue) {
        this.progress -= 10;
      }
    },
  },
  
};
</script>
<style lang="scss" scoped>
.info-btn-custom {
  background-color: white !important;
  &:hover {
    background-color: white !important;
    box-shadow: none;
  }
}
.step-progress__step:hover {
  cursor: pointer;
}
.action-text {
  opacity: 1 !important;
  transform: unset !important;
  font-size: 14px !important;
}
.custom-step-pro::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  height: 2px;
  width: 96%;
  background-color: grey;
  z-index: -1;
}
.custom-step-pro:last-child::before {
  content: none;
}

.new-profile .step-progress__wrapper .step-progress__bar .favourite_list .notify{
  background-color: #2C632C !important;
}

@media screen and (max-width: 1280px) and (min-width: 600px) {
  .custom-step-pro:nth-child(4),
  .custom-step-pro:nth-child(5) {
    margin-top: 130px;
  }
  .custom-step-pro:nth-child(3)::before {
    content: none;
  }
  .cus-step-wrap {
    padding-top: 20px;
  }
  .step-progress__step:after {
    width: 30px !important;
    height: 30px !important;
  }
  .step-progress__step span {
    font-size: 18px;
  }
  .step-progress__step-icon {
    font-size: 12px !important;
  }
}
@media only screen and (max-width: 600px) {
  .custom-step-pro::before {
    left: -6%;
    top: 369%;
    width: 27%;
    transform: rotate(90deg);
  }
  .custom-step-pro {
    margin-bottom: 80px;
  }
  .step-progress__step-label .arrow-up {
    display: none;
  }
  .step-progress__step:after {
    left: 8%;
    top: 150%;
  }
  .step-progress__step-icon {
    left: 8%;
    top: 150%;
  }
  .step-progress__step-label {
    top: 0;
    left: 63%;
  }
  .custom-step-pro:nth-child(4),
  .custom-step-pro:nth-child(5) {
    margin-top: unset;
  }
  .step-progress__step:after {
    width: 30px !important;
    height: 30px !important;
  }
  .step-progress__step span {
    font-size: 18px;
  }
  .step-progress__step-icon {
    font-size: 12px !important;
  }
  .cus-step-wrap {
    padding-top: 20px;
  }
  
  
}
</style>
